module.exports = __webpack_public_path__ + "static/img/qrcode.4baa9f3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qrcode.jpg
// module id = Ftoc
// module chunks = 3